module.exports = __webpack_public_path__ + "static/media/comp-grinding-s.86ce08ab.jpg";